// Fix U (2026-10-13): test ids de la academia (AAME Academy).
// Los que terminan en Prefix llevan el id del registro al final.

export const ACADEMY = {
        agendaAbsentPrefix: 'academy-agenda-absent-',
        agendaAttendedPrefix: 'academy-agenda-attended-',
        agendaDateInput: 'academy-agenda-date-input',
        agendaEmpty: 'academy-agenda-empty',
        agendaLate: 'academy-agenda-late',
        agendaList: 'academy-agenda-list',
        agendaNextButton: 'academy-agenda-next-button',
        agendaPage: 'academy-agenda-page',
        agendaPrevButton: 'academy-agenda-prev-button',
        agendaRowPrefix: 'academy-agenda-row-',
        agendaStatusPrefix: 'academy-agenda-status-',
        agendaTodayButton: 'academy-agenda-today-button',
        agendaUndoPrefix: 'academy-agenda-undo-',
        attendanceAttendedPrefix: 'academy-attendance-attended-',
        attendanceModal: 'academy-attendance-modal',
        attendanceNoShowPrefix: 'academy-attendance-no-show-',
        attendanceRowPrefix: 'academy-attendance-row-',
        attendanceStatusPrefix: 'academy-attendance-status-',
        attendedButtonPrefix: 'academy-attended-button-',
        billCounter: 'academy-bill-counter',
        billInputPrefix: 'academy-bill-input-',
        cashChargeButton: 'academy-cash-charge-button',
        cashCloseButton: 'academy-cash-close-button',
        cashCloseConfirm: 'academy-cash-close-confirm',
        cashCloseModal: 'academy-cash-close-modal',
        cashCloseNote: 'academy-cash-close-note',
        cashClosedBanner: 'academy-cash-closed-banner',
        cashDifference: 'academy-cash-difference',
        cashExpected: 'academy-cash-expected',
        cashMovementButton: 'academy-cash-movement-button',
        cashOpenButton: 'academy-cash-open-button',
        cashOpenForm: 'academy-cash-open-form',
        cashPage: 'academy-cash-page',
        cashSession: 'academy-cash-session',
        cashTable: 'academy-cash-table',
        changeDateButtonPrefix: 'academy-change-date-button-',
        chargeAmountInput: 'academy-charge-amount-input',
        chargeEnrollmentSelect: 'academy-charge-enrollment-select',
        chargeMethodSelect: 'academy-charge-method-select',
        chargeModal: 'academy-charge-modal',
        chargeSaveButton: 'academy-charge-save-button',
        chargeSearchInput: 'academy-charge-search-input',
        chargeStudentPrefix: 'academy-charge-student-',
        coinsInput: 'academy-coins-input',
        commissionAmountPrefix: 'academy-commission-amount-',
        commissionDetailPrefix: 'academy-commission-detail-',
        commissionMyClosed: 'academy-commission-my-closed',
        commissionMyCollected: 'academy-commission-my-collected',
        commissionMyCommission: 'academy-commission-my-commission',
        commissionMyLeads: 'academy-commission-my-leads',
        commissionMyNext: 'academy-commission-my-next',
        commissionMyPanel: 'academy-commission-my-panel',
        commissionPayPrefix: 'academy-commission-pay-',
        commissionRowPrefix: 'academy-commission-row-',
        commissionTogglePrefix: 'academy-commission-toggle-',
        commissionsExecutivesTab: 'academy-commissions-executives-tab',
        commissionsInstructorsTab: 'academy-commissions-instructors-tab',
        commissionsMonthInput: 'academy-commissions-month-input',
        commissionsPage: 'academy-commissions-page',
        commissionsTable: 'academy-commissions-table',
        commissionsTotal: 'academy-commissions-total',
        countTotal: 'academy-count-total',
        courseCardPrefix: 'academy-course-card-',
        courseContractInput: 'academy-course-contract-input',
        courseDiplomaInput: 'academy-course-diploma-input',
        courseDiplomaPreview: 'academy-course-diploma-preview',
        courseEditButtonPrefix: 'academy-course-edit-button-',
        courseManualInput: 'academy-course-manual-input',
        courseManualLink: 'academy-course-manual-link',
        courseModal: 'academy-course-modal',
        courseNameInput: 'academy-course-name-input',
        coursePracticesInput: 'academy-course-practices-input',
        coursePriceInput: 'academy-course-price-input',
        courseReservationInput: 'academy-course-reservation-input',
        courseSaveButton: 'academy-course-save-button',
        coursesAddButton: 'academy-courses-add-button',
        coursesEmpty: 'academy-courses-empty',
        coursesPage: 'academy-courses-page',
        creditAmountInput: 'academy-credit-amount-input',
        creditModal: 'academy-credit-modal',
        creditSaveButton: 'academy-credit-save-button',
        diplomaLinkPrefix: 'academy-diploma-link-',
        diplomaMissingPrefix: 'academy-diploma-missing-',
        editionAddButtonPrefix: 'academy-edition-add-button-',
        editionAttendanceButtonPrefix: 'academy-edition-attendance-button-',
        editionCapacityInput: 'academy-edition-capacity-input',
        editionEditButtonPrefix: 'academy-edition-edit-button-',
        editionInstructorPrefix: 'academy-edition-instructor-',
        editionLocationInput: 'academy-edition-location-input',
        editionModal: 'academy-edition-modal',
        editionRowPrefix: 'academy-edition-row-',
        editionSaveButton: 'academy-edition-save-button',
        editionStartInput: 'academy-edition-start-input',
        editionStartTimeInput: 'academy-edition-start-time-input',
        editionStatusSelect: 'academy-edition-status-select',
        editionTierPricePrefix: 'academy-edition-tier-price-',
        editionTierUntilPrefix: 'academy-edition-tier-until-',
        emailCard: 'academy-email-card',
        emailLast: 'academy-email-last',
        emailStatus: 'academy-email-status',
        emailTestButton: 'academy-email-test-button',
        emailTestInput: 'academy-email-test-input',
        enrollDiscountInput: 'academy-enroll-discount-input',
        enrollEditionSelect: 'academy-enroll-edition-select',
        enrollExecutiveSelect: 'academy-enroll-executive-select',
        enrollModal: 'academy-enroll-modal',
        enrollPriceBox: 'academy-enroll-price-box',
        enrollSaveButton: 'academy-enroll-save-button',
        enrollTotal: 'academy-enroll-total',
        enrollmentBalancePrefix: 'academy-enrollment-balance-',
        enrollmentCancelButtonPrefix: 'academy-enrollment-cancel-button-',
        enrollmentCardPrefix: 'academy-enrollment-card-',
        enrollmentConfirmButtonPrefix: 'academy-enrollment-confirm-button-',
        enrollmentContractPrefix: 'academy-enrollment-contract-',
        enrollmentCopyLinkPrefix: 'academy-enrollment-copy-link-',
        enrollmentInviteStatusPrefix: 'academy-enrollment-invite-status-',
        enrollmentLinkPrefix: 'academy-enrollment-link-',
        enrollmentPaidPrefix: 'academy-enrollment-paid-',
        enrollmentPayButtonPrefix: 'academy-enrollment-pay-button-',
        enrollmentPlanButtonPrefix: 'academy-enrollment-plan-button-',
        enrollmentProgressPrefix: 'academy-enrollment-progress-',
        enrollmentRefundButtonPrefix: 'academy-enrollment-refund-button-',
        enrollmentRefundsPrefix: 'academy-enrollment-refunds-',
        enrollmentResendInvitePrefix: 'academy-enrollment-resend-invite-',
        enrollmentStatusPrefix: 'academy-enrollment-status-',
        enrollmentWhatsappLinkPrefix: 'academy-enrollment-whatsapp-link-',
        expenseAddButton: 'academy-expense-add-button',
        expenseAmountInput: 'academy-expense-amount-input',
        expenseCategorySelect: 'academy-expense-category-select',
        expenseDateInput: 'academy-expense-date-input',
        expenseDescriptionInput: 'academy-expense-description-input',
        expenseModal: 'academy-expense-modal',
        expenseSaveButton: 'academy-expense-save-button',
        expensesTable: 'academy-expenses-table',
        expireButtonPrefix: 'academy-expire-button-',
        financeDownloadButton: 'academy-finance-download-button',
        financeExpenses: 'academy-finance-expenses',
        financeExpensesTab: 'academy-finance-expenses-tab',
        financeIncome: 'academy-finance-income',
        financeMonthInput: 'academy-finance-month-input',
        financePage: 'academy-finance-page',
        financeResult: 'academy-finance-result',
        homeEditionsTable: 'academy-home-editions-table',
        homeLeadsSummary: 'academy-home-leads-summary',
        homePage: 'academy-home-page',
        homeTilePrefix: 'academy-home-tile-',
        instructorAmountPrefix: 'academy-instructor-amount-',
        instructorPayPrefix: 'academy-instructor-pay-',
        instructorRowPrefix: 'academy-instructor-row-',
        instructorsTable: 'academy-instructors-table',
        leadCourseSelect: 'academy-lead-course-select',
        leadEditButtonPrefix: 'academy-lead-edit-button-',
        leadEmailInput: 'academy-lead-email-input',
        leadEnrollButtonPrefix: 'academy-lead-enroll-button-',
        leadExecutiveSelect: 'academy-lead-executive-select',
        leadModal: 'academy-lead-modal',
        leadNameInput: 'academy-lead-name-input',
        leadNoteInput: 'academy-lead-note-input',
        leadNotesButtonPrefix: 'academy-lead-notes-button-',
        leadPhoneInput: 'academy-lead-phone-input',
        leadRowPrefix: 'academy-lead-row-',
        leadSaveButton: 'academy-lead-save-button',
        leadSourceSelect: 'academy-lead-source-select',
        leadStageSelect: 'academy-lead-stage-select',
        leadStageSelectPrefix: 'academy-lead-stage-select-',
        leadWhatsappPrefix: 'academy-lead-whatsapp-',
        leadsAddButton: 'academy-leads-add-button',
        leadsEmpty: 'academy-leads-empty',
        leadsPage: 'academy-leads-page',
        leadsSearchInput: 'academy-leads-search-input',
        leadsStageFilterPrefix: 'academy-leads-stage-filter-',
        leadsTable: 'academy-leads-table',
        modalError: 'academy-modal-error',
        moveButtonPrefix: 'academy-move-button-',
        moveEditionSelect: 'academy-move-edition-select',
        moveModal: 'academy-move-modal',
        moveSaveButton: 'academy-move-save-button',
        movementAmountInput: 'academy-movement-amount-input',
        movementCategorySelect: 'academy-movement-category-select',
        movementModal: 'academy-movement-modal',
        movementReasonInput: 'academy-movement-reason-input',
        movementSaveButton: 'academy-movement-save-button',
        movementTypeSelect: 'academy-movement-type-select',
        noShowBoxPrefix: 'academy-no-show-box-',
        noShowButtonPrefix: 'academy-no-show-button-',
        notesAddButton: 'academy-notes-add-button',
        notesInput: 'academy-notes-input',
        notesModal: 'academy-notes-modal',
        notionCard: 'academy-notion-card',
        notionFilesError: 'academy-notion-files-error',
        notionStatus: 'academy-notion-status',
        notionSyncButton: 'academy-notion-sync-button',
        notionTestButton: 'academy-notion-test-button',
        paymentAmountInput: 'academy-payment-amount-input',
        paymentMethodSelect: 'academy-payment-method-select',
        paymentModal: 'academy-payment-modal',
        paymentReservationCheck: 'academy-payment-reservation-check',
        paymentSaveButton: 'academy-payment-save-button',
        paymentVoidPrefix: 'academy-payment-void-',
        payoutMethodSelect: 'academy-payout-method-select',
        payoutModal: 'academy-payout-modal',
        payoutNoteInput: 'academy-payout-note-input',
        payoutSaveButton: 'academy-payout-save-button',
        planAddButton: 'academy-plan-add-button',
        planAmountPrefix: 'academy-plan-amount-',
        planDatePrefix: 'academy-plan-date-',
        planDiscountInput: 'academy-plan-discount-input',
        planEditor: 'academy-plan-editor',
        planModal: 'academy-plan-modal',
        planSaveButton: 'academy-plan-save-button',
        portalAcceptCheckbox: 'academy-portal-accept-checkbox',
        portalBalance: 'academy-portal-balance',
        portalConfirmed: 'academy-portal-confirmed',
        portalContractDownload: 'academy-portal-contract-download',
        portalContractSection: 'academy-portal-contract-section',
        portalContractText: 'academy-portal-contract-text',
        portalCourseName: 'academy-portal-course-name',
        portalDiplomaDownload: 'academy-portal-diploma-download',
        portalDiplomaMissing: 'academy-portal-diploma-missing',
        portalDiplomaSection: 'academy-portal-diploma-section',
        portalError: 'academy-portal-error',
        portalFieldPrefix: 'academy-portal-field-',
        portalFormEdit: 'academy-portal-form-edit',
        portalFormError: 'academy-portal-form-error',
        portalFormSection: 'academy-portal-form-section',
        portalFormSubmit: 'academy-portal-form-submit',
        portalManualDownload: 'academy-portal-manual-download',
        portalManualSection: 'academy-portal-manual-section',
        portalNoShow: 'academy-portal-no-show',
        portalNoShowAnswered: 'academy-portal-no-show-answered',
        portalNoShowDateSelect: 'academy-portal-no-show-date-select',
        portalNoShowError: 'academy-portal-no-show-error',
        portalNoShowExplain: 'academy-portal-no-show-explain',
        portalNoShowMessage: 'academy-portal-no-show-message',
        portalNoShowReschedule: 'academy-portal-no-show-reschedule',
        portalNoShowSubmit: 'academy-portal-no-show-submit',
        portalPage: 'academy-portal-page',
        portalPaid: 'academy-portal-paid',
        portalPayBalanceButton: 'academy-portal-pay-balance-button',
        portalPayError: 'academy-portal-pay-error',
        portalPayReservationButton: 'academy-portal-pay-reservation-button',
        portalPaySection: 'academy-portal-pay-section',
        portalPendingNotice: 'academy-portal-pending-notice',
        portalNextPractices: 'academy-portal-next-practices',
        portalPractices: 'academy-portal-practices',
        portalRefreshButton: 'academy-portal-refresh-button',
        portalSignButton: 'academy-portal-sign-button',
        portalSignError: 'academy-portal-sign-error',
        portalSignerInput: 'academy-portal-signer-input',
        portalStatus: 'academy-portal-status',
        practiceAbsentPrefix: 'academy-practice-absent-',
        practiceAddButtonPrefix: 'academy-practice-add-button-',
        practiceAttendedPrefix: 'academy-practice-attended-',
        practiceDateInputPrefix: 'academy-practice-date-input-',
        practiceRowPrefix: 'academy-practice-row-',
        practiceScheduleButtonPrefix: 'academy-practice-schedule-button-',
        practiceStatusPrefix: 'academy-practice-status-',
        practiceTimeInputPrefix: 'academy-practice-time-input-',
        practiceUndoPrefix: 'academy-practice-undo-',
        practicesBoxPrefix: 'academy-practices-box-',
        practicesCountPrefix: 'academy-practices-count-',
        rateInputPrefix: 'academy-rate-input-',
        ratesTab: 'academy-rates-tab',
        ratesTable: 'academy-rates-table',
        reasonConfirmButton: 'academy-reason-confirm-button',
        reasonDialog: 'academy-reason-dialog',
        reasonInput: 'academy-reason-input',
        refundAmountInput: 'academy-refund-amount-input',
        refundApprovePrefix: 'academy-refund-approve-',
        refundModal: 'academy-refund-modal',
        refundReasonInput: 'academy-refund-reason-input',
        refundRejectPrefix: 'academy-refund-reject-',
        refundSaveButton: 'academy-refund-save-button',
        refundsPending: 'academy-refunds-pending',
        settingsContractInput: 'academy-settings-contract-input',
        settingsFormFields: 'academy-settings-form-fields',
        settingsIncludeReservations: 'academy-settings-include-reservations',
        settingsInstructorBase: 'academy-settings-instructor-base',
        settingsModeFlat: 'academy-settings-mode-flat',
        settingsModeMarginal: 'academy-settings-mode-marginal',
        settingsNotionInput: 'academy-settings-notion-input',
        settingsPage: 'academy-settings-page',
        settingsReservationInput: 'academy-settings-reservation-input',
        settingsSaveButton: 'academy-settings-save-button',
        settingsTiers: 'academy-settings-tiers',
        studentCredit: 'academy-student-credit',
        studentEditButton: 'academy-student-edit-button',
        studentEmailInput: 'academy-student-email-input',
        studentEnrollButton: 'academy-student-enroll-button',
        studentFormData: 'academy-student-form-data',
        studentModal: 'academy-student-modal',
        studentName: 'academy-student-name',
        studentNameInput: 'academy-student-name-input',
        studentPage: 'academy-student-page',
        studentPhoneInput: 'academy-student-phone-input',
        studentRowPrefix: 'academy-student-row-',
        studentSaveButton: 'academy-student-save-button',
        studentsAddButton: 'academy-students-add-button',
        studentsDebtFilter: 'academy-students-debt-filter',
        studentsEmpty: 'academy-students-empty',
        studentsPage: 'academy-students-page',
        studentsSearchInput: 'academy-students-search-input',
        studentsTable: 'academy-students-table',
        toCreditButtonPrefix: 'academy-to-credit-button-',
        useCreditButtonPrefix: 'academy-use-credit-button-',
        coursesLoadCatalogButton: 'academy-courses-load-catalog-button',
        webPage: 'academy-web-page',
        webLoginLink: 'academy-web-login-link',
        webCatalog: 'academy-web-catalog',
        webFilterPrefix: 'academy-web-filter-',
        webCourseRowPrefix: 'academy-web-course-row-',
        webInfoButtonPrefix: 'academy-web-info-button-',
        webForm: 'academy-web-form',
        webNameInput: 'academy-web-name-input',
        webPhoneInput: 'academy-web-phone-input',
        webEmailInput: 'academy-web-email-input',
        webCourseSelect: 'academy-web-course-select',
        webMessageInput: 'academy-web-message-input',
        webSubmit: 'academy-web-submit',
        webSuccess: 'academy-web-success',
        webError: 'academy-web-error',
        webWhatsapp: 'academy-web-whatsapp',
};
